import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { addTariffRate, updateTariffRate } from 'utils/TariffRatesAPIUtils';
import Store from 'stores/TariffRatesStore';
import _ from 'underscore';
import TariffRatesEditor from './TariffRatesEditor';
import RatesValidator from './RatesValidator';
import Types from './TariffRatesTypes';
export default class TariffRatesEditModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasBeenEdited: false,
            valid: false,
            tariffRate: props.tariffRate || this.newTariffRate(),
        };
        this.onChange = () => this.onStoreChange();
    }
    componentDidMount() {
        Store.addChangeListener(this.onChange);
    }
    componentWillUnmount() {
        Store.removeChangeListener(this.onChange);
    }
    onStoreChange() {
        if (Store.getStatus() === 'success') {
            const propsTariffRate = this.props.tariffRate;
            const storeTariffRate = Store.getTariffRate();
            if (storeTariffRate._id) {
                this.setState({ tariffRate: _.extend({}, storeTariffRate) });
            }
            else {
                this.setState({ tariffRate: _.extend({}, propsTariffRate) });
            }
        }
    }
    newTariffRate() {
        return {
            name: '',
            type: 'weightDistance',
            fsc: 1,
            distance_ranges: [],
            weight_ranges: [],
            prices: [],
            od_pairs: [],
            rate_per_day: 0,
        };
    }
    close() {
        return () => {
            if (this.props.onClose) {
                this.props.onClose();
            }
        };
    }
    save() {
        return () => {
            if (this.state.tariffRate) {
                Store.reset();
                addTariffRate(this.state.tariffRate);
            }
            this.setState({ hasBeenEdited: false, valid: false });
        };
    }
    update() {
        return () => {
            const tariffRate = this.state.tariffRate;
            if (tariffRate) {
                tariffRate.is_ready = RatesValidator(this.state.tariffRate, Types);
                Store.reset();
                updateTariffRate(tariffRate);
            }
            this.setState({ tariffRate: tariffRate, hasBeenEdited: false, valid: false });
        };
    }
    onTariffRateChange() {
        return (updatedTariffRate, edited, valid) => {
            this.setState({ hasBeenEdited: edited, valid: valid, tariffRate: updatedTariffRate });
        };
    }
    render() {
        const newTariffRateMode = !this.state.tariffRate || !this.state.tariffRate._id;
        const disableSaveButton = !(this.state.hasBeenEdited && this.state.valid);
        return (React.createElement(Modal, Object.assign({}, this.props, { onHide: this.close() }),
            React.createElement(Modal.Header, { closeButton: true }),
            React.createElement(Modal.Body, null,
                React.createElement(TariffRatesEditor, { tariffRate: this.state.tariffRate, onChange: this.onTariffRateChange() })),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { onClick: this.close() }, "Close"),
                "\u00A0",
                React.createElement("span", { onClick: (newTariffRateMode) ? this.save() : this.update() },
                    React.createElement(Button, { bsStyle: "primary", disabled: disableSaveButton }, (newTariffRateMode) ? 'Save' : 'Save Changes')))));
    }
}
